module.exports = __webpack_public_path__ + "static/media/Level_Shapes.c67e5c78.svg";